<cb-dialog class="flex-col"
           dialogHeading="Complete Multiple Activities">
    <cb-table [loaded]="data != null">
        <thead cbTableHead>
        <tr>
            <td></td>
            <td>PO #</td>
            <td>Job Number</td>
            <td>Activity</td>
        </tr>
        </thead>
        <tbody cbTableBody>
            @for (element of data.purchaseOrders; track element) {
                <tr
                    class="overflow-hidden">
                    <td class="overflow-hidden">
                        @if (!inProgress[element.id] && !successful[element.id] && !failed[element.id]) {
                            <mat-icon class="cb-grey"
                                      matTooltip="Complete not in progress">radio_button_unchecked
                            </mat-icon>
                        }
                        @if (inProgress[element.id] && !successful[element.id] && !failed[element.id]) {
                            <mat-spinner
                                diameter="20"
                                matTooltip="Complete in progress"></mat-spinner>
                        }
                        @if (successful[element.id]) {
                            <mat-icon
                                color="primary"
                                matTooltip="Complete Succeeded">check_circle
                            </mat-icon>
                        }
                        @if (failed[element.id]) {
                            <mat-icon
                                class="cb-error"
                                [matTooltip]="failed[element.id]">cancel
                            </mat-icon>
                        }
                    </td>
                    <td>{{ element.orderNumber }}</td>
                    <td>{{ element.jobNumber }}</td>
                    <td>{{ element.activityName }}</td>
                </tr>
            }
        </tbody>
    </cb-table>
    <div actions>
        <button mat-raised-button
                (cbClick)="completeAll()"
                [clickLimit]="1"
                color="primary">Complete All
        </button>
        <button mat-raised-button
                (click)="cancel()">Close
        </button>
    </div>
</cb-dialog>
